import ProfilePageContent from "./ProfilePageContent";

export default ProfilePageContent;
